import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';

const collapsableCss = ".collapse-container{display:grid;transition-timing-function:var(--tt-animation-easing-smooth)}.collapse-container[data-direction=vertical]{grid-template-rows:0fr;transition-property:grid-template-rows}.collapse-container[data-direction=vertical][data-open]:not([data-open=false]){grid-template-rows:1fr}.collapse-container[data-direction=horizontal]{grid-template-columns:0fr;transition-property:grid-template-columns;max-width:fit-content}.collapse-container[data-direction=horizontal][data-open]:not([data-open=false]){grid-template-columns:1fr}@media (prefers-reduced-motion){.collapse-container{transition:1ms !important}}";

const Collapsable = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.ttAfterHide = createEvent(this, "tt-after-hide", 7);
    this.ttAfterShow = createEvent(this, "tt-after-show", 7);
    this.hideOverflow = false;
    this.duration = '250ms';
    this.open = false;
    this.direction = 'vertical';
    this.keen = false;
  }
  connectedCallback() {
    this.hideOverflow = !this.open;
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
  }
  handleTransitionStart() {
    this.hideOverflow = true;
  }
  handleTransitionEnd() {
    if (this.open) {
      this.hideOverflow = false;
      this.ttAfterShow.emit();
    }
    else {
      this.ttAfterHide.emit();
    }
  }
  render() {
    return (h("div", { class: "collapse-container", style: { transitionDuration: this.duration }, "data-open": this.open, "data-direction": this.direction, onTransitionEnd: this.handleTransitionEnd }, h("div", { style: { overflow: this.hideOverflow ? 'hidden' : 'visible' },
      // @ts-expect-errors inert is a valid global attribute
      inert: this.open || this.keen ? undefined : 'inert' }, h("slot", null))));
  }
  static get watchers() { return {
    "open": ["handleTransitionStart"]
  }; }
  static get style() { return collapsableCss; }
}, [1, "tt-collapsable", {
    "duration": [1],
    "open": [4],
    "direction": [1],
    "keen": [4],
    "hideOverflow": [32]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-collapsable"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-collapsable":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Collapsable);
      }
      break;
  } });
}

export { Collapsable as C, defineCustomElement as d };
